import { render, staticRenderFns } from "./Vitec.vue?vue&type=template&id=089c5d3b&"
import script from "./Vitec.vue?vue&type=script&lang=js&"
export * from "./Vitec.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/main.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports